// export const BASE_ROUTE = "http://localhost:8000/api/temps";
export const BASE_ROUTE = "https://peaceful-beach-51988.herokuapp.com/api/temps";
export const SHOW = `${BASE_ROUTE}/show`;
export const SHOW_ALL = `${BASE_ROUTE}/showAll`;
export const COMMENT = `${BASE_ROUTE}/comment`;